var StripePaymentRequest = (function () {
    var _stripe;
    var _paymentRequest;
    var _button;
    var _beforePayAsync;
    var _pay;

    var getPaymentRequestSettings = function (amount) {
        return {
            country: GlobalSettings.Iso.toUpperCase(),
            currency: GlobalSettings.Currency.toLowerCase(),
            total: {
                label: "Total",
                amount: parseInt(amount * 100)
            },
            requestPayerName: false,
            requestPayerEmail: false,
            requestPayerPhone: false,
            requestShipping: false
        };
    }

    var _createPaymentRequest = function (amount) {
        var settings = getPaymentRequestSettings(amount);
        var paymentRequest = _stripe.paymentRequest(settings);
        return paymentRequest;
    };

    var _updatePaymentRequest = function (amount) {
        var settings = getPaymentRequestSettings(amount);
        _paymentRequest.update({total: settings.total});
    };

    var _mountButton = function (paymentRequest, el) {
        var deff = new $.Deferred();

        // Check the availability of the Payment Request API first.
        paymentRequest.canMakePayment().then(function (result) {

            if (result && !_button) {
                var elements = _stripe.elements();
                _button = elements.create("paymentRequestButton", {
                    paymentRequest: paymentRequest,
                    style: {
                        paymentRequestButton: {
                            theme: 'light',
                            // One of 'dark', 'light', or 'light-outline'
                            // Defaults to 'dark'
                            height: '42px'
                            // Defaults to '40px'. The width is always '100%'.
                        },
                    },
                });
            }

            if (result) {
                _button.mount(el || "#stripePaymentRequestButton");
                $('#stripePaymentRequestButton').removeClass('hidden-block');
                deff.resolve(paymentRequest, _button);
            }
        });

        return deff.promise();
    };

    var _subscribeEvents = function (paymentRequest, button) {
        paymentRequest.on('paymentmethod', function (ev) {
            _pay && _pay({
                id: ev.paymentMethod.id,
                paymentType: "stripePayButton"
            }).done(function () {
                ev.complete('success');
            });
        });

        button.on('click', function (e) {
            e.preventDefault();
            var deff = _beforePayAsync && _beforePayAsync();
            deff && deff.done(function () {
                paymentRequest.show();
            });
        });
    }



    return {
        init: function (stripe, beforePayAsync, pay, amount, el) {
            _stripe = stripe;
            _beforePayAsync = beforePayAsync;
            _pay = pay;

            _paymentRequest = _createPaymentRequest(amount);
            _mountButton(_paymentRequest, el).done(_subscribeEvents);
        },
        update: function (amount) {
            if (!_paymentRequest) return;
            _updatePaymentRequest(amount);
        },
        mountButton: function (el) {
            if (!el || !_button) return;
            _button.unmount();
            _button.mount(el);
        }
    };
});